import { createFileRoute, notFound } from "@tanstack/react-router"

// Catch-all for genuinely unknown paths.
//
// Every valid region-less marketing route is prerendered (lib/utils/static-
// routes.ts) and every region-prefixed route is matched under /$countryCode,
// so anything reaching here is a 404 and must return that status. Previously
// this route rendered a region-redirect probe that resolved to nothing,
// serving an empty shell with HTTP 200 — which meant Google would index every
// mistyped and spam-probed URL as a thin page, and Search Console could never
// report a broken link because nothing ever returned an error.
//
// throw notFound() is what actually sets the SSR status here; calling
// setResponseStatus(404) from a loader renders the right page but leaves the
// response at 200 (verified against the built server).
export const Route = createFileRoute("/$")({
  loader: () => {
    throw notFound()
  },
})
